import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["query", "type"],
    _excluded2 = ["abortSignal"];

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(addressBackup);

import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import fetch from 'isomorphic-unfetch';
import { call, put, cancelled } from 'redux-saga/effects';
import { SEARCH_ADDRESS_BACKUP, REVERSE_ADDRESS_BACKUP, GET_LIST } from '../actions/constants';
var MAPBOX_TOKEN = process.env.MAPBOX_TOKEN || 'pk.eyJ1IjoiZG9jYXZlbnVlIiwiYSI6ImNqeTRrbWE0czE2Yzkzbm84N2h2eXJqZnEifQ.ShwQF4w48FQ1i94KuesGCQ';
var MAPBOX_API_BASE_URL = 'https://api.mapbox.com/geocoding/v5'; // TODO: add streetmapapi, algolia_place if we want more backup solution

var searchAddressBackupViaAPI = function searchAddressBackupViaAPI(restInstance) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var query, type, params, abortSignal, newParams, res, newData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            query = _ref.query, type = _ref.type, params = _objectWithoutProperties(_ref, _excluded);
            abortSignal = params.abortSignal, newParams = _objectWithoutProperties(params, _excluded2);
            _context.next = 4;
            return restInstance.runQueryCrud(GET_LIST, 'pat-public/localities', _objectSpread(_objectSpread({}, newParams), {}, {
              query: query
            }), null, null, abortSignal);

          case 4:
            res = _context.sent;
            newData = res.data.items.filter(function (item) {
              return item.type.toLowerCase() === 'city';
            }).map(function (item) {
              return {
                properties: _objectSpread(_objectSpread({}, item), {}, {
                  label: item.name,
                  postcode: item.postCode,
                  type: 'municipality',
                  city: item.name,
                  citycode: item.code
                }),
                geometry: item.location
              };
            });
            return _context.abrupt("return", newData.slice(0, params.limit || 20));

          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var searchAddressBackupViaMapbox = function searchAddressBackupViaMapbox(restInstance) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
      var query, abortSignal;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            query = _ref3.query, abortSignal = _ref3.abortSignal;
            return _context2.abrupt("return", fetch("".concat(MAPBOX_API_BASE_URL, "/mapbox.places/").concat(query, ".json?country=fr&access_token=").concat(MAPBOX_TOKEN), _objectSpread(_objectSpread({}, restInstance.httpOptions), {}, {
              signal: abortSignal
            })).then(function (res) {
              return res.json();
            }).then(function (data) {
              return data.features;
            }).then(function (features) {
              return features.map(function (feature) {
                return _objectSpread(_objectSpread({}, feature), {}, {
                  properties: _objectSpread(_objectSpread({}, feature.properties), {}, {
                    label: feature.place_name,
                    name: feature.place_name,
                    city: feature.place_name,
                    postcode: feature.postcode || "[".concat(feature.geometry.coordinates.join(', '), "]"),
                    id: feature.id,
                    type: 'street' // Force use location to search

                  })
                });
              });
            }));

          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var searchAddressBackup = function searchAddressBackup(restInstance) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
      var payload, abortSignal, res, opts;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            payload = _ref5.payload, abortSignal = _ref5.abortSignal;
            opts = _objectSpread(_objectSpread({}, payload), {}, {
              query: payload.q,
              type: payload.type,
              abortSignal: abortSignal
            });

            if (!opts.type.includes('municipality')) {
              _context3.next = 6;
              break;
            }

            _context3.next = 5;
            return searchAddressBackupViaAPI(restInstance)(opts).catch(function () {
              return null;
            });

          case 5:
            res = _context3.sent;

          case 6:
            if (!(!res || res.length === 0)) {
              _context3.next = 10;
              break;
            }

            _context3.next = 9;
            return searchAddressBackupViaMapbox(restInstance)(opts);

          case 9:
            res = _context3.sent;

          case 10:
            return _context3.abrupt("return", res);

          case 11:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref6.apply(this, arguments);
    };
  }();
};

var reverseAddressBackupViaMapbox = function reverseAddressBackupViaMapbox(restInstance) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
      var location, abortSignal;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            location = _ref7.location, abortSignal = _ref7.abortSignal;
            return _context4.abrupt("return", fetch("".concat(MAPBOX_API_BASE_URL, "/mapbox.places/").concat(location.long, ",").concat(location.lat, ".json?country=fr&access_token=").concat(MAPBOX_TOKEN), _objectSpread(_objectSpread({}, restInstance.httpOptions), {}, {
              signal: abortSignal
            })).then(function (res) {
              return res.json();
            }).then(function (data) {
              return data.features;
            }).then(function (features) {
              return features.map(function (feature) {
                return _objectSpread(_objectSpread({}, feature), {}, {
                  properties: _objectSpread(_objectSpread({}, feature.properties), {}, {
                    label: feature.place_name,
                    id: feature.id,
                    type: 'street' // Force use location to search

                  })
                });
              });
            }));

          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref8.apply(this, arguments);
    };
  }();
};

var reverseAddressBackup = function reverseAddressBackup(restInstance) {
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref9) {
      var payload, abortSignal, opts, res;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            payload = _ref9.payload, abortSignal = _ref9.abortSignal;
            opts = _objectSpread(_objectSpread({}, payload), {}, {
              location: {
                long: payload.long,
                lat: payload.lat
              },
              abortSignal: abortSignal
            });
            _context5.next = 4;
            return reverseAddressBackupViaMapbox(restInstance)(opts);

          case 4:
            res = _context5.sent;
            return _context5.abrupt("return", res);

          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref10.apply(this, arguments);
    };
  }();
};

export default function addressBackup(restInstance, action) {
  var abortController, type, data, _data;

  return _regeneratorRuntime.wrap(function addressBackup$(_context6) {
    while (1) switch (_context6.prev = _context6.next) {
      case 0:
        abortController = new AbortController();
        type = action.type;

        if (!(type === SEARCH_ADDRESS_BACKUP)) {
          _context6.next = 23;
          break;
        }

        _context6.prev = 3;
        _context6.next = 6;
        return call(searchAddressBackup(restInstance), _objectSpread(_objectSpread({}, action), {}, {
          abortSignal: abortController.signal
        }));

      case 6:
        data = _context6.sent;
        _context6.next = 9;
        return put({
          type: "".concat(type, "_SUCCESS"),
          payload: data,
          query: {}
        });

      case 9:
        _context6.next = 15;
        break;

      case 11:
        _context6.prev = 11;
        _context6.t0 = _context6["catch"](3);
        _context6.next = 15;
        return put({
          type: "".concat(type, "_FAILED")
        });

      case 15:
        _context6.prev = 15;
        _context6.next = 18;
        return cancelled();

      case 18:
        if (!_context6.sent) {
          _context6.next = 20;
          break;
        }

        abortController.abort();

      case 20:
        return _context6.finish(15);

      case 21:
        _context6.next = 42;
        break;

      case 23:
        if (!(type === REVERSE_ADDRESS_BACKUP)) {
          _context6.next = 42;
          break;
        }

        _context6.prev = 24;
        _context6.next = 27;
        return call(reverseAddressBackup(restInstance), _objectSpread(_objectSpread({}, action), {}, {
          abortSignal: abortController.signal
        }));

      case 27:
        _data = _context6.sent;
        _context6.next = 30;
        return put({
          type: "".concat(type, "_SUCCESS"),
          payload: _data,
          query: {}
        });

      case 30:
        _context6.next = 36;
        break;

      case 32:
        _context6.prev = 32;
        _context6.t1 = _context6["catch"](24);
        _context6.next = 36;
        return put({
          type: "".concat(type, "_FAILED")
        });

      case 36:
        _context6.prev = 36;
        _context6.next = 39;
        return cancelled();

      case 39:
        if (!_context6.sent) {
          _context6.next = 41;
          break;
        }

        abortController.abort();

      case 41:
        return _context6.finish(36);

      case 42:
      case "end":
        return _context6.stop();
    }
  }, _marked, null, [[3, 11, 15, 21], [24, 32, 36, 42]]);
}
//# sourceMappingURL=addressBackup.js.map